// extracted by css-extract-rspack-plugin
export default {"BrandCircle":"DashboardInfoSidebar-module__BrandCircle___LLe27","IconMargin":"DashboardInfoSidebar-module__IconMargin___rD80B"};